import { indexedDBLocalPersistence } from "firebase/auth";

import { PersistenceFactory } from "./index.d";

export const getReactNativePersistence: PersistenceFactory =
  () => indexedDBLocalPersistence;
